var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$options.buttons),function(btn){return _c('b-button',{key:btn.id,staticClass:"ml-1 mt-0",attrs:{"size":"sm","pressed":_vm.isMetricButtonSelected(btn.id),"variant":btn.variant},on:{"click":function($event){return _vm.changeMetric(btn)}}},[_vm._v("\n      "+_vm._s(btn.caption)+"\n  ")])}),1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ea3074","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/expertoRetail/atoms/MetricSwitchButtons/MetricSwitchButtons.vue
// module id = 861
// module chunks = 72